import React from 'react';
import RealEstateOverlay from './RealEstateOverlay';
import PlacesListOverlay from './PlacesListOverlay';

function GeoLocationOverlays({ realEstateOverlayProps, placesOverlayProps }) {
    return (
        <>
            <RealEstateOverlay {...realEstateOverlayProps} />
            <PlacesListOverlay {...placesOverlayProps} />
        </>
    );
}

export default GeoLocationOverlays;
